import { Image, LI, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../service";
import ProfileBox from "./ProfileBox";

const UserProfile = () => {
  return (
    <LI className="profile-nav onhover-dropdown p-0">
      <div className="d-flex profile-media align-items-center">
        <Image className="b-r-10 img-40" src={dynamicImage("dashboard-8/user3.png")} alt="user" />
        <div className="flex-grow-1">
          <span>{"Haris"}</span>
          <P className="mb-0">{"Lead Software Architect"}</P>
        </div>
      </div>
      <ProfileBox />
    </LI>
  );
};

export default UserProfile;
